import React from "react";

const ErrorMessage = ({ message, marginBottom, fontSize }) => {
  return (
    <p
      style={{
        fontSize: fontSize ? fontSize : "12px",
        fontFamily: "inter_600",
        color: "#ff4848",
        marginBottom: marginBottom ? marginBottom : "1rem",
        padding: "3px",
        paddingBottom: 0,
        paddingTop:"8px",
        paddingBottom:"8px"
        // whiteSpace: "nowrap",
      }}
    >
      {message}
    </p>
  );
};
export default ErrorMessage;
